import { atom } from "jotai"
import { type ViewFmpProjectQuery } from "../../../type-and-hooks"

export const sortedOrderAtom = atom<Array<ViewFmpProjectQuery["viewFMPProject"][0]>>([])

// Atom to control when table rows are draggable in edit mode
export const isReorderModeAtom = atom<boolean>(false)
